import lozad from 'lozad'
import AppBase from 'app-base'

const App = AppBase

export default class PageBase {
  static init () {
    this.handleDocumentLoading()
    globalThis.PageController = this
  }

  static handleDocumentLoading () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this._handleDOMReady.bind(this))
    } else {
      setTimeout(this._handleDOMReady.bind(this), 0)
    }

    if (App.stylesApplied) {
      this.handleStylesApplied()
    } else {
      document.addEventListener('app:styles:applied', this.handleStylesApplied.bind(this))
    }
  }

  static _handleDOMReady () {
    // need to wait until App class is finished initializing on dom ready
    if (App.DOMReadyHandled) {
      console.debug('[Page] waiting for App.DOMReadyHandled')
      setTimeout(() => this._handleDOMReady(), 10)
      return
    }
    // ensure handler called only once
    if (this.DOMReadyHandled) return
    this.DOMReadyHandled = true
    this.handleDOMReady()
  }

  static handleDOMReady () {
    this.render()
  }

  static handleStylesApplied () {
    // interface
  }

  static render () {
    // interface
  }

  static get props () { return document.body.dataset }

  static onEnter (selector, callback) {
    if (typeof window === 'undefined' || !window.IntersectionObserver) {
      console.error('PageBase.onEnter(): IntersectionObserver is not available')
      callback()
      return
    }

    lozad(selector, {
      load: () => {
        callback()
      },
    }).observe()
  }
}
